import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { createContext, useContext } from 'react';

const PrescriptionFormInputContext = /*#__PURE__*/ createContext(null);
PrescriptionFormInputContext.displayName = 'PrescriptionFormInputContext';
const usePrescriptionFormInput = ()=>{
    const context = useContext(PrescriptionFormInputContext);
    if (context === null) {
        throw new Error('No PrescriptionFormInputContext available.');
    }
    return context;
};
var PrescriptionFormInputProvider = (_param)=>{
    var { children  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    const value = React.useMemo(()=>{
        const { parentId , name  } = props;
        const idPrefix = `${parentId}-${name}`;
        return swcHelpers.objectSpread({}, props, {
            idPrefix,
            selectId: `${idPrefix}-select`,
            labelId: `${idPrefix}-label`,
            selectName: `prescription-select-${name}`
        });
    }, [
        props
    ]);
    return /*#__PURE__*/ React.createElement(PrescriptionFormInputContext.Provider, {
        value: value
    }, children);
};

export { PrescriptionFormInputContext, PrescriptionFormInputProvider, usePrescriptionFormInput };
//# sourceMappingURL=PrescriptionFormInputContext.js.map
